module.exports = __webpack_public_path__ + "cm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cm.svg
// module id = 495
// module chunks = 0